import { canAccess, FULL_ACCESS, RBAC_MODULES } from '../lib/rbac'

// The reply boxes are textareas so a Quick Answer suggestion can carry line breaks, but
// everything staff type or paste keeps the old single-line <input> behaviour.

// True while an IME (Vietnamese Telex/VNI, CJK) is composing: Enter then confirms the
// composition and must not send the message.
export const isImeComposing = (e) => Boolean(e?.nativeEvent?.isComposing)

// Enter sends (Shift+Enter is allowed to pass on desktop); never while composing.
export const isSendEnter = (e, { allowShift = false } = {}) =>
  e.key === 'Enter' && !isImeComposing(e) && (allowShift ? !e.shiftKey : true)

export const flattenPastedText = (text) => String(text ?? '').replace(/[\r\n]+/g, ' ')

// A <input> turned newlines in pasted text into spaces; do the same in a <textarea>.
export function handleReplyPaste(e, setValue) {
  const text = e.clipboardData?.getData('text') ?? ''
  if (!/[\r\n]/.test(text)) return
  e.preventDefault()
  const el = e.currentTarget
  const start = el.selectionStart ?? el.value.length
  const end = el.selectionEnd ?? el.value.length
  const flat = flattenPastedText(text)
  const caret = start + flat.length
  setValue(el.value.slice(0, start) + flat + el.value.slice(end))
  requestAnimationFrame(() => {
    try { el.setSelectionRange(caret, caret) } catch { /* element gone */ }
  })
}

// The store role defaults to 'admin' until the profile/branch role has loaded, so the
// suggestion button waits for the bootstrap to finish (authStore sets it to 'ready' right
// after syncRoleForBranch has written the effective branch role into the store).
export const canStaffReply = (role, branchBootstrapStatus) =>
  branchBootstrapStatus === 'ready' && canAccess(role, RBAC_MODULES.conversations, FULL_ACCESS)
